
class Observable {
    constructor() {
      this.observers = { };
    }
    subscribe(event,fn) {
			if(!this.observers[event]) this.observers[event] = [];
      this.observers[event].push(fn);
    }
    unsubscribe(event,fn) {
			if(!this.observers[event]) return;
      this.observers = this.observers[event].filter(subscriber => subscriber !== fn);
    }
    notify(event,data) {
			console.log('observer notified',event);
			if(!this.observers[event]) return;
      this.observers[event].forEach(fn => fn(data));
    }
}


class Queue {
    constructor() {
      this.queue = {};
    }
    add(event,fn) {
			if(!this.queue[event]) this.queue[event] = [];
      this.queue[event].push(fn);
    }
    process(event,data) {
			console.log('queue processed',event);
			if(!this.queue[event]) return;
			this.queue[event].forEach(fn => fn(data));
			this.queue[event] = [];
    }
}


export {
    Observable,
    Queue
}
